import type { UseQueryOptions } from '@tanstack/react-query';
import type { HTTPError } from 'ky';

export type PresetUseQueryOptions<TQueryFnData, TData = TQueryFnData> = Omit<
  UseQueryOptions<TQueryFnData, HTTPError, TData>,
  'queryKey' | 'queryFn'
>;

export enum Status {
  success = 'success',
  failed = 'failed',
  processing = 'processing',
  needs_attention = 'needs_attention',
}
